import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import NavigatorBridge from './NavigatorBridge.jsx';
import { EVENT_DATA } from '../lib/event.js';

// Public layout used by Home, Confirmacion and Login.
// Renders the wedding header, the routed content, and a minimal footer.
export default function Layout() {
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-cream-gradient font-body text-text">
      <NavigatorBridge />
      <header className="border-b border-gold/30 bg-creamTop/40 backdrop-blur-sm">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4">
          <Link
            to="/"
            className="font-script text-2xl text-gold-deep"
            style={{ fontFamily: "'Great Vibes', 'Allura', cursive" }}
          >
            {EVENT_DATA.couple.display}
          </Link>
          <nav>
            {user && (
              <Link to="/admin" className="text-sm text-ink/70 hover:text-gold-deep">
                Ir al panel
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-4 text-center text-xs text-text-muted">
          {EVENT_DATA.couple.display} · {EVENT_DATA.date.humanShort}
        </div>
      </footer>
    </div>
  );
}
